import UmsActionTypes from './types';

const initialState = {
  userList: [],
  rolesList: [],
  vehiclesList: [],
  permissionList: {},
  showSpinner: false,
  isUserAdded: false,
};

const UmsReducer = (state: object = initialState, action: { type: string; payload: any }) => {
  switch (action.type) {
    case UmsActionTypes.FETCH_OPERATOR_SUBORDINATES_START:
      return {
        ...state,
        userList: [],
        showSpinner: true,
      };
    case UmsActionTypes.FETCH_OPERATOR_SUBORDINATES_SUCCESS:
      return {
        ...state,
        userList: action.payload,
        showSpinner: false,
      };
    case UmsActionTypes.FETCH_OPERATOR_SUBORDINATES_FAILURE:
      return {
        ...state,
        userList: [],
        showSpinner: false,
      };
    case UmsActionTypes.FETCH_ALL_ROLES_START:
      return {
        ...state,
        rolesList: [],
      };
    case UmsActionTypes.ADD_USER_START:
      return {
        ...state,
        isUserAdded: false,
      };
    case UmsActionTypes.ADD_USER_SUCCESS:
      return {
        ...state,
        isUserAdded: true,
      };
    case UmsActionTypes.REMOVE_USER_SUCCESS:
      return {
        ...state,
        isUserAdded: false,
      };
    case UmsActionTypes.FETCH_ALL_ROLES_SUCCESS:
      return {
        ...state,
        rolesList: action.payload,
      };
    case UmsActionTypes.FETCH_ALL_VEHICLES_START:
      return {
        ...state,
        vehiclesList: [],
      };
    case UmsActionTypes.FETCH_ALL_VEHICLES_SUCCESS:
      return {
        ...state,
        vehiclesList: action.payload,
      };
    case UmsActionTypes.FETCH_PERMISSION_START:
      return {
        ...state,
        permissionList: {},
      };
    case UmsActionTypes.FETCH_PERMISSION_SUCCESS:
      return {
        ...state,
        permissionList: action.payload,
      };
    default:
      return state;
  }
};
export default UmsReducer;
